import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cbd19ecc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "links" }
const _hoisted_2 = { class: "links__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_tag_link_name = _resolveComponent("l-tag-link-name")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (l) => {
        return (_openBlock(), _createBlock(_component_l_tag_link_name, {
          key: l.id,
          link: l,
          "onDelete:link": _ctx.updateLinks
        }, null, 8, ["link", "onDelete:link"]))
      }), 128))
    ])
  ]))
}